import React from 'react'
import { Heading } from '@myxplor/ui'
import ProviderLevelReportContainer from '../container'
import { ReportEmailAddress } from './_email'

const reportLabel = 'Provider Entitlements Report'

const FormFields = ({ values, errors, onChange }) => (
  <fieldset>
    <Heading small compact>
      {reportLabel}
    </Heading>

    <ReportEmailAddress
      reportLabel={reportLabel}
      value={values.email_address}
      errors={errors.email_address}
      onChange={onChange}
    />
  </fieldset>
)

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/providers/${gov_id}/provider-reports/entitlements`

export const ProviderLevelReportEntitlements = ({ gov_id, resetCurrentReport }) => (
  <ProviderLevelReportContainer
    url={formEndPoint({ gov_id })}
    name={reportLabel}
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
  />
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/entitlements.jsx